import Question from '../../interfaces/question';
import Survey from '../../interfaces/survey';

const getConditionalQuestion = (
  conditionalQuestionId: number,
  survey: Survey,
): Question | undefined => survey.questions.find((q) => q.id === conditionalQuestionId);

export default getConditionalQuestion;
